import { IBoxBuyIntegrationStore } from './index'

export default {
  status: 0,
  loading: true
} as IBoxBuyIntegrationStore
